import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sas-station.constants';

@Component({
  selector: 'app-sas-station-change-password-sent',
  templateUrl: './sas-station-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-station-change-password-sent.component.css',
  ],
})
export class SasStationChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
